module.exports = __webpack_public_path__ + "media/_archive/N-7e433318.png";